import { Button, Form, message, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { GetHistorical, GetLastSPAL, GetSPALActivity } from '../../../Api/getData';
import { useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const { Option } = Select;

const FilterSPAL = ({ onData, onDataToleransi }) => {

    const [searchParams] = useSearchParams();
    const KodeCabang = searchParams.get("KodeCabang") ? searchParams.get("KodeCabang") : "SGM";
    const ShipCode = searchParams.get("ShipCode") ? searchParams.get("ShipCode") : "G2008";

    const [loadings, setLoadings] = useState(false);
    const [form] = Form.useForm();

    const [dataSPAL, setDataSPAL] = useState([]);
    const [activity, setActivity] = useState([]);
    const [selectedSPAL, setSelectedSPAL] = useState(null);
    const [selectedActivity1, setSelectedActivity1] = useState(null);
    const [selectedActivity2, setSelectedActivity2] = useState(null);

    useEffect(() => {
        const fetchSPAL = async () => {
            try {
                const res = await GetLastSPAL(KodeCabang, ShipCode, 0);
                if (res && res.length > 0) {
                    setDataSPAL(res);
                    if (res.length > 0) {
                        const defaultSPAL = res[0];
                        setSelectedSPAL(defaultSPAL.SONumber);
                        form.setFieldsValue({
                            SPAL: defaultSPAL.SONumber,
                        });
                    }
                }
            } catch (error) {
                console.log(error);
            }
        };
        fetchSPAL();
    }, [KodeCabang, ShipCode, form]);

    useEffect(() => {
        const fetchActivity = async () => {
            try {
                const res = await GetSPALActivity(KodeCabang, selectedSPAL);
                setActivity(res);
                if (res && res.length > 0) {  // Ensure res is not null/undefined and has elements
                    const firstActivity = res[0];
                    const lastActivity = res[res.length - 1];
                    setSelectedActivity1(firstActivity.ActivityDate);
                    setSelectedActivity2(lastActivity.ActivityDate);
                    form.setFieldsValue({
                        activity1: firstActivity.ActivityDate,
                        activity2: lastActivity.ActivityDate,
                    });
                    fetchDataReading(dayjs.utc(firstActivity.ActivityDate).format('YYYY-MM-DD HH:mm:ss'), dayjs.utc(lastActivity.ActivityDate).format('YYYY-MM-DD HH:mm:ss'))
                }
            } catch (error) {
                console.error("Error fetching SPAL data:", error);
            }
        }

        fetchActivity();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [form, selectedSPAL]);

    const onSubmit = async (values) => {
        setLoadings(true);
        const { activity1, activity2 } = values;

        const startDateRange = dayjs.utc(activity1).format('YYYY-MM-DD HH:mm:ss');
        const endDateRange = dayjs.utc(activity2).format('YYYY-MM-DD HH:mm:ss');

        if (endDateRange && startDateRange && dayjs(endDateRange).isBefore(dayjs(startDateRange))) {
            message.error('Activity 2 cannot be before Activity 1');
            setLoadings(false);
            return;
        }

        try {
            await fetchDataReading(startDateRange, endDateRange);
        } catch (error) {
            console.log(error);
        } finally {
            setLoadings(false);
        }
    };


    const fetchDataReading = async (start, end) => {
        try {
            // const response = await getHistoryCal(start, end, onDataToleransi[0], onDataToleransi[1]);
            const response = await GetHistorical(KodeCabang, ShipCode, start, end, onDataToleransi[0], onDataToleransi[1]);
            onData(response);
        } catch (error) {
            console.log(error);
        } finally {
            setLoadings(false);
        }
    };

    return (
        <div>
            <Form
                onFinish={onSubmit}
                form={form}
                initialValues={{
                    SPAL: selectedSPAL,
                    activity1: selectedActivity1,
                    activity2: selectedActivity2,
                }}
            >
                <div className="w-full flex flex-col border rounded-xl items-end p-2 lg:p-4 gap-2 lg:gap-4">
                    <div className="flex flex-col gap-4">
                        <Form.Item
                            name="SPAL"
                            noStyle
                        >
                            <Select
                                onChange={(value) => setSelectedSPAL(value)}
                                style={{ minWidth: '100px', width: 'auto' }}
                                placeholder="Select SPAL"
                                popupMatchSelectWidth={false}
                            >
                                {dataSPAL.map((item, index) => (
                                    <Option key={index} value={item.SONumber}>
                                        {item.SONumber} - {item.IsFinish ? "FINISH" : "UNFINISHED"}
                                    </Option>
                                ))}
                            </Select>

                        </Form.Item>

                        <Form.Item
                            name="activity1"
                            noStyle
                        >
                            <Select
                                style={{ minWidth: '100px', width: 'auto' }}
                                placeholder="Select Activity 1"
                                popupMatchSelectWidth={false}
                            >
                                {activity.map((item) => (
                                    <Option key={item.DetailNo} value={item.ActivityDate}>
                                        {item.ActivityName} - {dayjs.utc(item.ActivityDate).format('YYYY-MM-DD HH:ss:ss')}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            name="activity2"
                            noStyle
                        >
                            <Select
                                style={{ minWidth: '100px', width: 'auto' }}
                                placeholder="Select Activity 2"
                                popupMatchSelectWidth={false}
                            >
                                {activity.map((item) => (
                                    <Option key={item.DetailNo} value={item.ActivityDate}>
                                        {item.ActivityName} - {dayjs.utc(item.ActivityDate).format('YYYY-MM-DD HH:ss:ss')}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </div>
                    <Button htmlType="submit" icon={<SearchOutlined />} loading={loadings} className="w-full lg:w-10" style={{ width: '100%' }} />
                </div>
            </Form>
        </div>
    );
}

export default FilterSPAL;
